// extracted by mini-css-extract-plugin
export default {"root":"AriaInfo-root-ac26922b116bd99c170b97a18c17d290"};